import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SectionIntro from "./SectionIntro";

const RestaurationFull = () => {
  const { t } = useTranslation();

  const fullMenu = [
    {
      category: "restaurationFull.categories.breakfast",
      items: [
        {
          name: "restaurationFull.items.moroccanBreakfast",
          description: "restaurationFull.descriptions.moroccanBreakfast",
          price: "40 MAD",
          perPerson: true,
        },
      ],
    },
    {
      category: "restaurationFull.categories.lunch",
      items: [
        {
          name: "restaurationFull.items.meatTajine",
          description: "restaurationFull.descriptions.meatTajine",
          specifications: [
            { weight: "1/4 kg", price: "60 MAD" },
            { weight: "0.5 kg", price: "90 MAD" },
            { weight: "1 kg", price: "150 MAD" },
          ],
        },
        {
          name: "restaurationFull.items.chickenTajine",
          description: "restaurationFull.descriptions.chickenTajine",
          specifications: [
            { weight: "1/4 kg", price: "60 MAD" },
            { weight: "0.5 kg", price: "90 MAD" },
            { weight: "1 kg", price: "150 MAD" },
          ],
        },
      ],
    },
    {
      category: "restaurationFull.categories.seasonal",
      items: [
        {
          name: "restaurationFull.items.seasonalFruit",
          description: "restaurationFull.descriptions.seasonalFruit",
          price: "40 MAD",
        },
      ],
    },
    {
      category: "restaurationFull.categories.beverages",
      items: [
        {
          name: "restaurationFull.items.mintTea",
          description: "restaurationFull.descriptions.mintTea",
          price: "20 MAD",
        },
        {
          name: "restaurationFull.items.sparklingWater",
          description: "restaurationFull.descriptions.sparklingWater",
          price: "15 MAD",
        },
        {
          name: "restaurationFull.items.otherBeverages",
          description: "restaurationFull.descriptions.otherBeverages",
          price: "restaurationFull.prices.otherBeverages",
        },
      ],
    },
  ];

  const priceText = (price) =>
    price.startsWith("restaurationFull") ? t(price) : price;

  return (
    <section className="bg-cream pt-32 md:pt-40 pb-24">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <SectionIntro
          eyebrow={t("labels.dining")}
          title={t("restaurationFull.title")}
          lead={t("restaurationFull.subtitle")}
          className="mb-16 md:mb-20"
        />

        <div className="space-y-16 md:space-y-20">
          {fullMenu.map((section, si) => (
            <motion.div
              key={si}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7 }}
            >
              <div className="text-center mb-10">
                <h2 className="font-serif font-light text-3xl md:text-4xl text-ink">
                  {t(section.category)}
                </h2>
                <div className="rule-gold mx-auto mt-4" />
              </div>

              <div className="space-y-8">
                {section.items.map((item, ii) => (
                  <div key={ii}>
                    <div className="flex items-baseline gap-3">
                      <h3 className="font-serif text-xl md:text-2xl text-ink font-light">
                        {t(item.name)}
                      </h3>
                      <span className="flex-1 border-b border-dotted border-ink/25 translate-y-[-3px]" />
                      {item.price && (
                        <span className="text-brass font-medium whitespace-nowrap">
                          {priceText(item.price)}
                        </span>
                      )}
                    </div>

                    {item.perPerson && (
                      <p className="eyebrow text-brass mt-1 text-[10px]">
                        {t("restaurationFull.perPerson")}
                      </p>
                    )}

                    <p className="text-ink-muted font-light mt-2 leading-relaxed">
                      {t(item.description)}
                    </p>

                    {item.specifications && (
                      <div className="mt-4 space-y-2">
                        {item.specifications.map((spec, sp) => (
                          <div
                            key={sp}
                            className="flex items-baseline gap-3 text-sm"
                          >
                            <span className="text-ink-soft tracking-wide uppercase text-xs">
                              {spec.weight}
                            </span>
                            <span className="flex-1 border-b border-dotted border-ink/15 translate-y-[-3px]" />
                            <span className="text-brass font-medium whitespace-nowrap">
                              {spec.price}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="text-center mt-20"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Link
            to="/booking"
            className="inline-flex items-center justify-center bg-ink hover:bg-brass text-cream text-[12px] uppercase tracking-[0.22em] py-4 px-12 transition-colors duration-300"
          >
            {t("restaurationFull.reserveTable")}
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default RestaurationFull;
